// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"LoadingWrapper_spinnerContainer__SHhG0"};